<template>
    <div>
        <h2 class="headline-s form-headline-dealer-app">Application Type</h2>
        <div class="notification-bar-wrapper-no-bg">
            <div class="drop-ship-banner">
                <span class="drop-ship-leftside">
                    <p class="title-s banner-title">
                        Application Type
                    </p>
                    <span class="cta-wrapper">
                        <button 
                            type="button" 
                            :class="`${ !existingDealerOption ? 'small' : 'secondary small'} shipping-button-dealer-app${!existingDealerOption ? '-selected' : ''}`"
                            @click="setExistingDealerOption(false)">
                                New
                        </button>   
                        <button 
                            type="button" 
                            :class="`${ existingDealerOption ? 'small' : 'secondary small'} shipping-button-dealer-app${existingDealerOption ? '-selected' : ''}`"
                            @click="setExistingDealerOption(true)">
                                Existing
                        </button>
                    </span>
                </span>
            </div>
        </div>
        <div class="field-type-dealer-app" v-if="existingDealerOption">
            <div class="field-state-dealer-app input-folder" v-if="!props.isLoggedIn">
                <div class="input-folder--input">
                    <InputText 
                        :aria-required="true"
                        id="email_address" v-model="email_address"
                        :class="{
                            'invalid-state-input': errors.email_address != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="email_address" :class="{'invalid-state': errors.email_address}">
                        <p>Email Address *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.email_address">{{ errors.email_address }}</p></div>
            </div>
            <div class="authorization-form input-row-dealer-app" v-if="!props.isLoggedIn">
                <PasswordInput 
                    :aria-required="true"
                    v-model="password" 
                    :errors="passwordTests" 
                    id="password" 
                    class="field-state-dealer-app"
                    placeholder="Password *"/>
                <PasswordInput 
                    :aria-required="true"
                    v-model="password_confirmation" 
                    :errors="errors.password_confirmation" 
                    id="password_confirmation" 
                    placeholder="Confirm Password *"
                    class="field-state-dealer-app"
                />
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputText 
                        :aria-required="true"
                        id="rothco_dealer_no" v-model="rothco_dealer_no"
                        :class="{
                            'invalid-state-input': errors.rothco_dealer_no != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="rothco_dealer_no" :class="{'invalid-state': errors.rothco_dealer_no}">
                        <p>Dealer Number *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.rothco_dealer_no">{{ errors.rothco_dealer_no }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputText 
                        :aria-required="true"
                        id="zip" v-model="zip"
                        :class="{
                            'invalid-state-input': errors.zip != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="zip" :class="{'invalid-state': errors.zip}">
                        <p>Zip/Postal Code *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.zip">{{ errors.zip }}</p></div>
            </div>
        </div>
        <p class="field-state-dealer-app paragraph-default" style="width:100%">Note: This form is only for existing Rothco dealers who do not yet have an online account.</p>


    </div>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import PasswordInput from "@/components/PasswordInput.vue";
    import InputText from "primevue/inputtext";
    let existingDealerOption = defineModel("existingDealerOption", {type: Boolean, default: false});
    let rothco_dealer_no = defineModel("rothco_dealer_no", {type: String, default: ''});
    let zip = defineModel("zip", {type: String, default: ''});
    let password = defineModel("password", {type: String, default: ''});
    let password_confirmation = defineModel("password_confirmation", {type: String, default: ''});
    let email_address = defineModel("email_address", {type: String, default: ''});
    let errors = defineModel("errors", {
        type: Object,
        default(){
            return {};
        }
    });
    let route = inject("route");
    let props = defineProps({
        isLoggedIn: {
            type: Boolean,
            default: false
        }
    })
    let passwordTests = computed(()=>{
       let passwordErrors = Object.keys(errors.value).filter((key) => {
           return key === 'password';
       }).map((key) => {
           return errors.value[key];
       });
       return passwordErrors
    })
    let setExistingDealerOption = (option) => {
        existingDealerOption.value = option;
    };
</script>